import { render } from "./ChatMessageUpdate.vue?vue&type=template&id=33f07fbf"
import script from "./ChatMessageUpdate.vue?vue&type=script&lang=js"
export * from "./ChatMessageUpdate.vue?vue&type=script&lang=js"

import "./ChatMessageUpdate.vue?vue&type=style&index=0&id=33f07fbf&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__